<template>
    <div style="text-align: left">
        <div class="herd">
            <div class="list">统计批次</div>
        </div>

        <div class="content">
            <div class="goods">
                <div>
                    <div class="condition">
                        时间区域： <div class="block">
                            <el-date-picker type="datetime" v-model="info.startTime" @change="timeChange" placeholder="选择日期时间"
                                style="max-width: 200px">
                            </el-date-picker>
                        </div>&nbsp;&nbsp;
                        至&nbsp;&nbsp;
                        <div class="block">
                            <el-date-picker type="datetime" :disabled="info.startTime !== null ? false : true" v-model="info.endTime" placeholder="选择日期时间"
                                style="max-width: 200px">
                            </el-date-picker>
                        </div>&nbsp;&nbsp;
                        批次名称：<el-input placeholder="请输入批次名称" v-model.trim="info.batchName" class="input-with-select"
                            style="max-width: 200px">
                        </el-input>&nbsp;&nbsp;
                        <el-button style="margin-left:20px" type="primary" @click="search" plain>搜 索</el-button>
                        <el-button style="margin-left:20px" type="primary" plain @click="reset">重 置</el-button>
                        <el-button style="margin-left:20px" type="primary" plain @click="returnPage">返 回</el-button>
                    </div>
                    <hr style="margin-top: 20px" />
                </div>
                <br />
            </div>
            <br />
            <!-- <div @click="export2Excel">导出表格</div> -->
            <div class="global-table-box">
                <el-table :data="tableData" border style="width: 100%;" tooltip-effect="dark" :cell-style="{}">
                    <!-- <el-table-column type="selection" width="55">
                    </el-table-column> -->
                    <el-table-column type="index" width="50" label="#" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="batchName" label="批次名称" width="270" align="center" header-align="center">
                    </el-table-column>
                    <el-table-column label="自有商品销售额(元)" prop="ownGoods" width="200" align="center" header-align="center"
                        max-width="500px">
                    </el-table-column>
                    <el-table-column prop="transportation" label="运输费用(元)" width="200" align="center" header-align="center"
                        max-width="500px">
                    </el-table-column>
                    <el-table-column label="销售总额(元)" width="200" header-align="center" align="center">
                        <template slot-scope="scope">
                            {{ totalCalculation(scope.row) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="ownGoodsCount" label="销售数量(件)" width="200" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="startTime" label="开始时间" width="200" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="endTime" label="结束时间" width="200" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column label="操作" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-button @click="export2Excel(scope.row)" type="text" size="small">导出数据</el-button>
                            <el-button type="text" size="small" @click="editorChild(scope.row)">详情</el-button>
                            <!-- <el-button @click="deleteGoodsOne(scope.row)" type="text" size="small">删除</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="block">
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="info.pageNum"
                    layout="prev, pager, next, jumper" :total="totalPage" :page-size="10">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import request from '../utils/request';

export default {

    data() {
        return {
            // 查询参数
            info: {
                schoolId: '',
                isPage: true,
                pageSize: 10,
                pageNum: 1,
                batchName: '',
                startTime: null,
                endTime: null
            },
            dataList: [
                { 'username': '小明', 'phone': '123456', 'gender': '男', 'age': '8' },
                { 'username': '小红', 'phone': '123456', 'gender': '男', 'age': '8' },
                { 'username': '小丽', 'phone': '123456', 'gender': '男', 'age': '8' },
            ],
            // 查询时间
            timeSectionState: "1", // 1 近三月 2 近半年 3 近一年
            // 指标数据
            statisticsData: {},
            // 地址
            options: [],
            // 批次列表
            tableData: [],
            // 总条数
            totalPage: 0
        };
    },
    created() {
        this.info.schoolId = this.$route.query.id
        this.getSchoolBatch()
    },
    mounted() {

    },
    methods: {
        // 返回上一页
        returnPage() {
            this.$router.go(-1)
        },
        // 查询学校批次
        async getSchoolBatch() {
            const res = await request({
                method: 'POST',
                url: 'admin/statistical/analysis/get/batch/list',
                data: this.info
            })
            // console.log(res);
            if (res.code === '200') {
                this.tableData = res.data && res.data.list
                this.totalPage = res.data && res.data.total
            } else {
                this.$message.error(res.message)
            }
        },
        // 条件查询
        search() {
            this.info.pageNum = 1
            this.getSchoolBatch()
        },

        // 分页
        handleCurrentChange() {
            this.getSchoolBatch()
        },
        // 详情
        editorChild(val) {
            // this.$router.push({ name: 'statisticsBacthGoods', query: { id: val.id } })
            this.$router.push({ path: '/statisticsBacthGoods', query: { id: val.id, schoolId: this.info.schoolId } });
        },
        // 计算销售总额
        totalCalculation(item) {
            return ((Number(item.ownGoods) * 100) - (Number(item.transportation) * 100)) / 100
        },
        // 导出表格
        export2Excel(val) {
            val.grossSales = ((val.ownGoods*100)+(val.transportation*100))/100
            // console.log(val);
            // return
            require.ensure([], () => {
                this.$message.success('导出中')
                const { export_json_to_excel } = require("../excel//Export2Excel");
                const tHeader = ['批次名称', '销售数量', '自有商品销售额', '物流费用', '总流水']; // 设置Excel的表格第一行的标题
                const filterVal = ["batchName", "ownGoodsCount", "ownGoods", "transportation", "grossSales"]; // 对象tableData中一个对象的属性
                const list = [val]; //把data里的tableData存到list
                const data = this.formatJson(filterVal, list); //对数据过滤
                const head = val.batchName + '商品销售量统计';
                // tHeader：第一行标题； data:要显示的数据；head：下载的文件名
                export_json_to_excel(tHeader, data, head);
            });
        },
        // 数据过滤
        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },
        // 时间改变
        timeChange(item) {
            if (item === null) {
                this.info.endTime = null
            }
        },
        // 重置
        reset() {
            this.info.pageNum = 1
            this.info.batchName = ''
            this.info.startTime = null
            this.info.endTime = null
            this.getSchoolBatch()
        }
    },

};
</script>

<style lang="scss" scoped>
.list {
    background-color: #2589ff;
    color: #fff;
    text-align: center;
    width: 106px;
    height: 36px;
    margin-right: 10px;
    font-size: 16px;
    line-height: 36px;
    display: inline-block;
    border-radius: 6px;
}

.content {
    margin: 20px 0 0 0;
    background-color: #e0e0e0;
    padding: 10px;
    border-radius: 5px;
}

.goods {
    background-color: #fff;
    border-radius: 5px;
    padding: 10px 20px;
}

.gross-container {
    width: 300px;
    height: 100px;
    background-color: #000;
    text-align: center;
    padding: 20px 0;
    color: #fff;
}

.condition {
    display: flex;
    line-height: 30px;
}

.herd {
    display: flex;
    justify-content: space-between;
}

.block {
    text-align: right;
    background-color: #fff;
}

// .global-table-box{
//     height: 200px;
//     overflow: hidden;
// }

.el-select .el-input {
    width: 130px;
}

.input-with-select .el-input-group__prepend {
    background-color: #fff;
}
</style>